// F4-1 — **HER ASK LALA DOOR: ONE PAGE, ONE ACTION, NAMED CLEAN FOR ADS.**
//
// Her order: *"A funnel door named clean for ads, fast, ONE action, the LANDER-1 speed laws.
// 'She already knows. Ask her anything.' energy."*
//
// **IT IS HOOKLESS ON PURPOSE, SO A GATE CALLS IT** (R7/R12's entry requirement, and `FunnelPage`'s
// own ruling one door over). This is the first thing a stranger who cost her money ever sees, and a
// component holding state inside App.tsx could only ever be checked by a regex over a
// twelve-thousand-line file. The one decision it makes — whether the tap goes to signup or straight
// into the conversation — is `talkStartPlan`'s, in `src/talkDoor.js`, where a fixture RUNS it; the
// page is handed the already-composed handler and is a pure function of its props.
//
// **HER *ONE ACTION* IS HELD AS A COUNT RATHER THAN AS A LAYOUT** (`f41-talk-door.mjs`): a second
// control added next year is exactly the *exploring* LANDER-1's laws forbid, and it has no error
// state — the page simply reads as a menu.
//
// **AND THE CHROME IS OFF BY DECLARATION RATHER THAN BY THIS COMPONENT DRAWING NOTHING** — `talk` is
// on `STANDALONE_PAGES`, which is L1's ruling: the chrome is NOT RENDERED rather than hidden by a
// rule, because a painted-out side menu still takes the tab order and a stranger who tabs into it is
// a stranger this page just lost.
//
// >>> WHAT THIS PAGE CANNOT MEET, NAMED RATHER THAN CLAIMED (R17/R160). <<<
// Her clause names **the LANDER-1 speed laws**, and LANDER-1 MEASURED that budget as unreachable for
// ANY route in this app: **TTI 9.2s against her 2s on Slow-4G with 4x CPU**, because a standalone
// route still ships the **1,231 KB app bundle**. That round's own repair — a separate entry point —
// is declared HERS and undecided, so this door inherits the number rather than claiming her budget.
// It is **no worse than the funnel doors her advertising already lands on**, which are app routes
// with the same bundle, and it is measurably better than not having the door at all.
import type { ReactNode } from "react";
import { TALK_COPY } from "../talkDoor.js";

export type TalkPageProps = {
  /** Composed at the call site from `talkStartPlan` — the page never asks who she is. */
  onStart: () => void;
  /**
   * >>> HER ITEM 2 SUPERSEDES F4-1's ONE-BUTTON DOOR FOR A STRANGER, AND ONLY FOR A STRANGER. <<<
   *
   * Her order names this page as *"the /talk capture page"* with her own copy and her own five
   * fields on it, so a visitor who is not signed in meets the FORM rather than a button that sends
   * her to a signup page to type the same things.
   *
   * **A MEMBER WHO IS ALREADY SIGNED IN STILL MEETS THE DOOR, WHICH IS F4-1's OWN RULING AND IS NOT
   * TOUCHED** (`talkStartPlan`): she has a room and a chart, so asking her to fill in her birth
   * details again to reach a conversation she can already open is the worst thing this page could do
   * to a paying member. Two facts, two surfaces (R18).
   */
  signedIn?: boolean;
  /**
   * **THE CAPTURE IS COMPOSED IN AS A NODE**, which is `FunnelPage`'s and `HomeShowcase`'s own
   * pattern: the form holds state, THIS PAGE STAYS HOOKLESS, and a gate goes on CALLING it and
   * reading the tree back (R7/R12). A capture imported and mounted here would take that reach away
   * from the one surface a stranger off an advertisement actually lands on.
   */
  capture?: ReactNode;
};

export function TalkPage({ onStart, signedIn = false, capture }: TalkPageProps) {
  // >>> A STRANGER MEETS HER CAPTURE. <<< `signedIn` DEFAULTS TO FALSE, so a caller that says
  // nothing gets the page her order describes rather than the door it replaces — and the capture is
  // required for it, or a page composed without one would render nothing at all for the one visitor
  // it exists for (R43's M8: an absent node and a correct door are the same blank screen).
  if (!signedIn && capture) {
    return (
      <section className="talk" data-talk="door">
        <div className="talk__inner">{capture}</div>
      </section>
    );
  }
  return (
    // R43: a `<section>` and NOT a `<main>`. The whole app already lives inside one `<main>`, and a
    // second landmark is a document outline a screen reader cannot navigate — which R43's census
    // refuses by name. The `<h1>` below is what names this page in that outline.
    <section className="talk" data-talk="door">
      <div className="talk__inner">
        <h1 className="talk__hook">{TALK_COPY.hook}</h1>
        <p className="talk__lede">{TALK_COPY.lede}</p>
        {/* HER ONE ACTION. It carries `data-talk-start` so a walk finds it by its KEY rather than by
            its words (R41) — ITEM A's own lesson, which cost five walkthroughs four days of
            measuring nothing when a label was reworded underneath them. */}
        <button className="button button--primary talk__start" type="button" data-talk-start="1" onClick={onStart}>
          {TALK_COPY.action}
        </button>
      </div>
    </section>
  );
}
